import { render, staticRenderFns } from "./RadialChart.vue?vue&type=template&id=6edf8d81&"
import script from "./RadialChart.vue?vue&type=script&lang=js&"
export * from "./RadialChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports